const integerInkFormatter = new Intl.NumberFormat('zh-CN', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatInkBalance = (value: number | string | null | undefined) => {
  const amount = Number(value || 0);
  return integerInkFormatter.format(Number.isFinite(amount) ? amount : 0);
};
